import { createSignal } from 'solid-js';

export type ToastKind = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  kind: ToastKind;
  text: string;
}

const [toasts, setToasts] = createSignal<Toast[]>([]);
let nextId = 1;

export function pushToast(kind: ToastKind, text: string): void {
  const toast: Toast = { id: nextId++, kind, text };
  setToasts((current) => [...current, toast]);
  setTimeout(() => dismissToast(toast.id), kind === 'error' ? 10_000 : 5_000);
}

export function dismissToast(id: number): void {
  setToasts((current) => current.filter((toast) => toast.id !== id));
}

export { toasts };
